import { Component } from '@angular/core';
import { Router, ActivationEnd, RouterLinkActive, RouterLink } from '@angular/router';
import { AuthService } from '../../_services/auth.service';
import { filter, tap } from 'rxjs/operators';

import { User } from '../../_models/user';
import { AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

const SUPPORT_EMAIL = 'npc_support@rewiretech.com';

@Component({
    selector: 'app-navmenu',
    templateUrl: './navmenu.component.html',
    styleUrls: ['./navmenu.component.css'],
    imports: [RouterLinkActive, RouterLink, AsyncPipe, MatIcon]
})
export class NavmenuComponent {

  schoolId = '';
  user: Promise<User>;
  readonly supportMailtoHref = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent('NPC Admin support request')}`;

  constructor(
    private router: Router,
    public auth: AuthService
  ) {
    this.user = this.auth.currentUser();
    router.events.pipe(
      filter(e => e instanceof ActivationEnd),
      tap(e => {
        this.schoolId = e['snapshot'].params.schoolId;
      })
    )
      .subscribe();
  }

}
